module.exports = __webpack_public_path__ + "static/media/pushback.02ba9173.png";